import { inject, injectable } from 'inversify'
import * as Api from '@xlearn/common';
import { PlayerModule } from '../api'
import { QuizBankService2, QuizServiceSymbol } from './services2'
import { replaceBasePathInContent } from '../shared/utils/base-path';

@injectable()
export class QuizPlayerModule implements PlayerModule {

  readonly name = 'quiz'
  
  constructor(
    @inject(QuizServiceSymbol)
    private quizService: QuizBankService2) {}

  start(instance: Api.SerializedAspectInstance): void {
    this.quizService.start(this.resolveQuizSource(instance), instance.details.finalQuizId);
  }

  reset(instance: Api.SerializedAspectInstance): void {
    this.quizService.reset(this.resolveQuizSource(instance), instance.details.finalQuizId);
  }

  private resolveQuizSource(instance: Api.SerializedAspectInstance) {
    const quizBankUri = replaceBasePathInContent(instance.basePath)(instance.details.files.quizBankUri);
    return { uri: quizBankUri, basePath: instance.basePath }
  }

  async stop() {
    await this.quizService.finish()
  }

}
